import * as mutation_types from '../mutation-types';

const state = {
    seen: [],
};

const mutations = {
    [mutation_types.ONBOARDING_SET] (state, seenOnboardingTips) {
        Vue.set(state, 'seen', seenOnboardingTips);
    },
    [mutation_types.ONBOARDING_UPDATE] (state, newSeenTip) {
        state.seen.push(newSeenTip);
    }
};

const getters = {
    ONBOARDING_GET: (state) => state.seen,
    ONBOARDING_IS_SEEN: (state) => (tip) => state.seen.includes(tip),
};

export default {
    state,
    mutations,
    getters,
}
